import { render } from "./OvApplicationCard.vue?vue&type=template&id=6c85ae1e&scoped=true"
import script from "./OvApplicationCard.vue?vue&type=script&lang=js"
export * from "./OvApplicationCard.vue?vue&type=script&lang=js"

import "./OvApplicationCard.vue?vue&type=style&index=0&id=6c85ae1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c85ae1e"]])

export default __exports__